// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jT4x","placeholdersHeader":"styles_placeholdersHeader__bOlr4","editorStyle":"styles_editorStyle__3DBUv","placeholdersBox":"styles_placeholdersBox__1oLrb"};